<template>
  <base-detail
    v-bind:title="$filters.localize('ContactCommunicationDetail.caption')"
    v-bind:rootId="rootId"
    v-bind:rootColumn="rootColumn"
    v-bind:schemaName="'contactcommunication'"
    v-bind:headers="headers"
    v-bind:entity="entity"
    v-bind:lookups="lookups"
    v-on:main-save="main - save"
    v-on:on-parrent-load="on - parrent - load"
  >
    <template
      v-if="entity.contactId"
      v-slot="{ entity, save }"
      class="input-group"
    >
      <form
        v-on:submit.prevent="save(entity)"
        class="input-group mb-3 detail-add-form"
      >
        <div
          class="detail-add-form__field detail-add-form__value detail-add-form__field--floating"
          :class="{ 'detail-add-form__field--filled': !!entity.value }"
        >
          <label class="detail-add-form__label">{{
            $filters.localize('main.value')
          }}</label>
          <input
            class="form-control detail-add-form__control"
            v-model="entity.value"
            required
          />
        </div>
        <div
          class="detail-add-form__field detail-add-form__type detail-add-form__field--floating"
          :class="{ 'detail-add-form__field--filled': !!entity.typeId }"
        >
          <label class="detail-add-form__label">{{
            $filters.localize('main.type')
          }}</label>
          <select
            class="form-control detail-add-form__control"
            v-model="entity.typeId"
            required
          >
            <option value="" disabled></option>
            <option
              v-for="option in lookups.types"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <button
          :disabled="!enabled"
          class="btn btn-primary detail-add-form__submit"
          type="submit"
        >
          {{ $filters.localize("button.add") }}
        </button>
      </form>
    </template>
  </base-detail>
</template>

<script>
import BaseDetail from "@/components/Sections/BaseDetail.vue";
export default {
  name: "ContactCommunicationDetail",
  components: { BaseDetail },
  emits: ["on-parrent-load", "main-save"],
  props: {
    rootId: { type: String, require: true },
    rootColumn: { type: String, require: true },
    enabled: { type: Boolean },
  },
  methods: {
    loadLookups() {
      this.$store
        .dispatch("section", { table: "communicationtype" })
        .then((response) => {
          this.lookups.types = response.data.data;
        });
    },
  },
  mounted() {
    this.loadLookups();
  },
  data() {
    return {
      lookups: {
        types: [],
      },
      entity: {
        typeId: "",
        contactId: this.rootId,
        value: "",
      },
      headers: [
        {
          field: "typeId",
          name: this.$filters.localize("main.size"),
          sort: true,
          lookup: "types",
          enabeled: true,
        },
        {
          field: "value",
          name: this.$filters.localize("main.value"),
          sort: true,
          input: true,
          enabeled: true,
        },
      ],
    };
  },
};
</script>

<style scoped>
.detail-add-form {
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0;
  position: relative;
  z-index: 20;
  width: 100%;
}

.detail-add-form__field {
  flex: 1 1 0;
  min-width: 0;
  height: 36px;
  min-height: 36px;
  position: relative;
}

.detail-add-form__field + .detail-add-form__field,
.detail-add-form__submit {
  margin-left: -1px;
}

.detail-add-form__field:focus-within,
.detail-add-form__control:focus {
  z-index: 2;
}

.detail-add-form__label {
  margin: 0;
  color: #7b8794;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  pointer-events: none;
}

.detail-add-form__field--floating .detail-add-form__label {
  position: absolute;
  top: 50%;
  left: 12px;
  z-index: 3;
  max-width: calc(100% - 24px);
  overflow: hidden;
  transform: translateY(-50%);
  transition: top 0.14s ease, transform 0.14s ease, font-size 0.14s ease, color 0.14s ease;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-add-form__field--floating:focus-within .detail-add-form__label,
.detail-add-form__field--floating.detail-add-form__field--filled .detail-add-form__label {
  top: 6px;
  transform: none;
  color: #4f7fa7;
  font-size: 0.58rem;
  text-transform: uppercase;
}

.detail-add-form__control {
  width: 100%;
  height: 36px;
  min-height: 36px;
  border-color: #ced4da;
  border-radius: 0;
  position: relative;
}

.detail-add-form__field--floating .form-control.detail-add-form__control {
  padding: 14px 12px 2px;
}

.detail-add-form__field--floating:not(.detail-add-form__field--filled):not(:focus-within) .form-control.detail-add-form__control {
  color: transparent;
}

.detail-add-form__field--floating:not(.detail-add-form__field--filled):not(:focus-within) .form-control.detail-add-form__control option {
  color: #495057;
}

.detail-add-form__value {
  min-width: 180px;
}

.detail-add-form__type {
  min-width: 160px;
}

.detail-add-form__value .detail-add-form__control {
  border-radius: 0.25rem 0 0 0.25rem;
}

.detail-add-form__submit {
  flex: 0 0 auto;
  height: 36px;
  min-height: 36px;
  padding-inline: 1rem;
  white-space: nowrap;
  border-radius: 0 0.25rem 0.25rem 0;
  position: relative;
  z-index: 1;
}

@media (max-width: 576px) {
  .detail-add-form {
    gap: 0.5rem;
  }

  .detail-add-form__field,
  .detail-add-form__submit,
  .detail-add-form__control {
    flex-basis: 100%;
    width: 100%;
    margin-left: 0;
    border-radius: 0.25rem;
  }
}
</style>
